import React, {forwardRef, useState} from "react";
import {t} from "i18next";
import {generateUUID2, imgPathPerfix} from "@/utils";
import {SYS_CONFIG_KEY_APPFIRST} from "@/Const";
import "../Home/FirstInitPage.scss"
import FirstInitGuiderPage from "@/views/Home/FirstInitGuiderPage";
import {getLeftPartSvg} from "@/views/Home/FirstInitIcon";

const FirstInitPage = forwardRef((props:{onStartClick:any}, ref)=>{
    const [toNext,setToNext] = useState(false);
    const arrayItems = [
        {
            id:"localStorage",
            image:'init_guider_1',
            title:t('Local file storage'),
            subTitle:t("LocalfileStorageSmall"),
            width:'36px',
            height:'26px'
        },
        {
            id:"fullFeatured",
            image:'init_guider_2',
            title:t('Infinite canvas'),
            subTitle:t("InfiniteCanvasSmall"),
            width:'33px',
            height:'27px'
        },
        {
            id:"powerfullPdf",
            image:'init_guider_3',
            title:t('Powerful highlighting'),
            subTitle:t("PowerfulHighlightSmall"),
            width:'31px',
            height:'29px'
        },
        // {
        //     id:"nestedBoards",
        //     image:'wel_nested_boards',
        //     title:t('Nested boards'),
        //     subTitle:t("UseBoardsAndCards"),
        //     width:'32px',
        //     height:'26px'
        // },
        {
            id:"organizeLocal",
            image:'init_guider_4',
            title:t('OrganizeLocalFiles'),
            subTitle:t("OrganizeLocalFilesSmall"),
            width:'30px',
            height:'26px'
        }
    ]


    const renderBase = ()=> {
        return <div className={'main-first- flex-row'} style={{margin:'60px',background:'white',width:'100%',borderRadius:'20px',boxShadow:'0px 4px 24px 0px rgba(0,0,0,0.2);'}}>
            <div className={'flex-center'} style={{width:'50%'}}>
                {getLeftPartSvg()}
            </div>
            {/*<div className={'flex-column-center'} style={{width: '50%', whiteSpace: 'pre-line'}}>*/}
            {/*    <div className={'flex-col'} style={{opacity: '1', width: '560px', minHeight: '760px'}}>*/}
            {/*        <div className={'flex-col'} style={{visibility: 'hidden', opacity: '0'}}>*/}
            {/*            <span className={'font-family-semi-bold'}*/}
            {/*                  style={{fontSize: '28px'}}>{t("Welcome to") + t("AppName")}</span>*/}
            {/*            <span style={{fontSize: '14px'}}>{t("AppName") + t("AppNameEmpowersYour")}</span>*/}
            {/*        </div>*/}

            {/*        <div className={'flex-row'}*/}
            {/*             style={{width: '560px', justifyContent: "space-around", flexWrap: 'wrap', marginTop: '36px'}}>*/}
            {/*            <div className={'react-init'} style={{marginLeft: '20px'}}>{t("Creative writing")}</div>*/}
            {/*            <div className={'react-init'}*/}
            {/*                 style={{marginTop: '30px', marginLeft: '60px'}}>{t("Research")}</div>*/}
            {/*            <div className={'react-init'}*/}
            {/*                 style={{marginTop: '-20px', marginLeft: '40px'}}>{t("Swipe files")}</div>*/}
            {/*            <div className={'react-init'}*/}
            {/*                 style={{marginTop: '120px', marginLeft: '-20px'}}>{t("Second brain")}</div>*/}
            {/*            <div className={'react-init'} style={{marginTop: '80px'}}>{t("Idea repository")}</div>*/}
            {/*            <div className={'react-init'} style={{marginTop: '160px'}}>{t("Mood board")}</div>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}

            <div className={'flex-col'} style={{width: '50%', justifyContent: 'center'}}>
                <div className={'flex-col'} style={{width: '560px', marginLeft: '66px'}}>
                    <span className={'font-family-semi-bold'}
                          style={{fontSize: '32px'}}>{t("Welcome to") + t("AppName")}</span>
                    <span style={{fontSize: '16px',marginTop:'20px'}}>{t("UnlockDeeperInsights")}</span>
                    <div style={{marginTop: '0px'}}>
                        {
                            arrayItems.map(item => <div className={'flex-row-vertical-center'}
                                                        style={{marginTop: '40px'}}>
                                <img style={{width: '24px', height: '24px'}}
                                     src={imgPathPerfix() + item.image + '.svg'}/>
                                <div className={'flex-col ml-16'}>
                                    <span className={'font-family-medium'}
                                          style={{fontSize: '17px'}}>{item.title}</span>
                                    <span style={{
                                        fontSize: '15px',
                                        color: '#666666',
                                        marginTop: '6px'
                                    }}>{item.subTitle}</span>
                                </div>
                            </div>)
                        }
                    </div>
                </div>
            </div>

            <div style={{
                minWidth: '128px',
                marginTop: '36px',
                height: '52px',
                fontStyle: '20px',
                borderRadius: '8px',
                position: 'absolute',
                left: '50%',
                transform: 'translateX(-50%)',
                bottom: '90px',
                fontSize: '18px'
            }} className='button-solid-style flex-center hovered' onClick={() => {
                setToNext(true);
                // if (props.onStartClick) {
                //     props.onStartClick();
                // }
            }}>{t("Next") + ' > '}</div>
        </div>
    }

    const renderGuider = ()=>{
        return <FirstInitGuiderPage onStartClick={props.onStartClick}/>
    }

    return (
        <div style={{
            display: 'flex',
            position: 'absolute',
            zIndex: '3001',
            left: '0px',
            top: '0px',
            width: '100%',
            height: '100%',
            background: '#E9F5FF'
        }}>
            {
                renderGuider()
            }

        </div>
    )
})

export default FirstInitPage;











































